clientAwarenessVersion